<template>
    <vPerformanceProductComponent :postList="postList" v-if="flag"></vPerformanceProductComponent>
</template>
<script>
import vPerformanceProductComponent from '../../listComponent/basicdata/performance/performanceProductComponent.vue';
export default {
    name: 'performance_product',
    components: {
        vPerformanceProductComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>